import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'building-grid',
  templateUrl: './building-grid.component.html',
  styleUrls: ['./building-grid.component.css']
})
export class BuildingGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/buildingdetails/building-grid/building-grid.component.ts